import { DataDRequest } from "../DRequest";
import type { IFinanzaAgrupadorCargos } from "../entidad/FinanzaAgrupadorCargos";
import { Global } from "../Global";
import { DataUtil } from "../util/Util";

/** Map<idEscuela, Map<ID, IFinanzaAgrupadorCargos>> */
export const _DICC_AGRUPADORES = new Map<number, Map<number, IFinanzaAgrupadorCargos>>();

export function _SvFinanzasObtenerListaAgrupadorCargos(idEscuela: number): Promise<DataDRequest.IRequestResponseA<IFinanzaAgrupadorCargos[]>> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/ObtenerListaAgrupadorCargos"
    const params = {
        "IdEscuela": idEscuela,
    }
    return DataDRequest._Request5<IFinanzaAgrupadorCargos[]>(url, "GET", params).then(res => {
        if (res.Resultado > 0 && res.Datos) {
            const mapAgrupadores = new Map<number, IFinanzaAgrupadorCargos>();
            res.Datos.forEach(agrupador => {
                mapAgrupadores.set(agrupador.Id, agrupador);
            });
            _DICC_AGRUPADORES.set(idEscuela, mapAgrupadores);
        }
        return res;
    })
}

type IAgrupadorAgregar = Pick<IFinanzaAgrupadorCargos, "Prefix" | "IncluyeAlumno" | "IncluyePeriodo" | "ProdServSAT" | "UnidadSAT">;
export function _SvFinanzasNuevoAgrupadorCargos(idEscuela: number, agrupador: IAgrupadorAgregar): Promise<DataDRequest.IRequestResponseA> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/NuevoAgrupadorCargos";
    const params = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdEscuela": idEscuela,
        "Prefix": agrupador.Prefix,
        "IncluyeAlumno": agrupador.IncluyeAlumno,
        "IncluyePeriodo": agrupador.IncluyePeriodo,
        "ProdServSAT": agrupador.ProdServSAT,
        "UnidadSAT": agrupador.UnidadSAT,
    }
    return DataDRequest._Request5(url, "POST", params);
}

type IAgrupadorActualizar = Pick<IFinanzaAgrupadorCargos, "Id" | "Prefix" | "IncluyeAlumno" | "IncluyePeriodo" | "ProdServSAT" | "UnidadSAT">;
export type IAgrupadorActualizarResponse = DataDRequest.IRequestResponseA & { NCargosPlantillaModificados?: number };
export function _SvFinanzasActualizarAgrupadorCargos(agrupador: IAgrupadorActualizar): Promise<IAgrupadorActualizarResponse> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/ActualizarAgrupadorCargos";
    const params = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdAgrupador": agrupador.Id,
        "Prefix": agrupador.Prefix,
        "IncluyeAlumno": agrupador.IncluyeAlumno,
        "IncluyePeriodo": agrupador.IncluyePeriodo,
        "ProdServSAT": agrupador.ProdServSAT,
        "UnidadSAT": agrupador.UnidadSAT,
    }
    return DataDRequest._Request5<undefined, IAgrupadorActualizarResponse>(url, "POST", params);
}

export type IAgrupadorEliminarResponse = DataDRequest.IRequestResponseA & { NCargosPlantillaDesasignados?: number };
export function _SvFinanzasEliminarAgrupadorCargos(idAgrupador: number): Promise<IAgrupadorEliminarResponse> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/EliminarAgrupadorCargos";
    const params = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdAgrupador": idAgrupador,
    }
    return DataDRequest._Request5<undefined, IAgrupadorEliminarResponse>(url, "POST", params);
}

export type IAgrupadorAsignarCargosResponse = DataDRequest.IRequestResponseA & { NCargosAsignados?: number, NCargosDesasignados?: number };
export function _SvFinanzasAsignarCargosAgrupador(idAgrupador: number, idsCargosAsignar: number[], idsCargosRemover: number[]): Promise<IAgrupadorAsignarCargosResponse> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/AsignarAgrupadorCargos";
    const params = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdAgrupador": idAgrupador,
        "IdsCargosAsignar": idsCargosAsignar,
        "IdsCargosRemover": idsCargosRemover,
    }
    return DataDRequest._Request5<undefined, IAgrupadorAsignarCargosResponse>(url, "POST", params);
}